module.exports = __webpack_public_path__ + "media/images/phi-internships-banner-277e36d213ebce370099ee51468dfb91.jpg";